<template>
  <v-card
    :elevation="focused ? 8 : 4"
    :class="'threadContainer ' + (focused ? ' focused ' : '')"
    @click.native.stop="() => $emit('click')"
  >
    <div v-if="focused" class="headActionsContainer">
      <div class="actions">
        <v-hover v-slot="{ hover }" v-if="!reflectionReadOnly">
          <v-btn icon @click="removeComment" :class="hover ? 'redButton' : ''">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-hover>
      </div>
    </div>
    <v-list class="commentList" ref="list" v-if="commentThread !== undefined">
      <template v-for="(cmt, index) in commentThread.comments">
        <Comment
          :comment="cmt"
          :key="cmt.userId + cmt.timestamp"
        />
        <v-divider class="ma-2"
                   :key="cmt.userId + cmt.timestamp + 'div'"
                   v-if="index + 1 < commentThread.comments.length"
        />
      </template>
    </v-list>
    <v-textarea
      v-if="focused && !reflectionReadOnly"
      outlined
      dense
      auto-grow
      hide-details
      class="px-2 pt-2"
      width="300px"
      rows="2"
      :placeholder="$t('actions.addThreadComment')"
      v-model="commentText"
    />
    <v-card-actions
      v-if="focused && !reflectionReadOnly"
    >
      <v-btn
        color="primary"
        x-small
        elevation="0"
        @click="setComment"
      >
        {{ $t('actions.comment') }}
      </v-btn>
      <v-btn
        x-small
        elevation="0"
        @click.stop="close"
      >
        {{ $t('actions.cancel') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import Comment from './Comment';
import { types } from '../../../../../store/rootTypes';

export default {
  name: 'CommentThread',
  components: {
    Comment,
  },
  props: {
    commentThread: {
      type: Object,
      required: true,
    },
    focused: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      commentText: '',
      isListScrolledBottom: false,
    };
  },
  mounted() {
    this.$refs.list.$el.addEventListener('scroll', this.onListScroll);
  },
  computed: {
    ...mapGetters({
      reflectionReadOnly: types.reflections.getters.reflectionReadOnly,
    }),
    previousComments() {
      console.log('preparing previousComments', this.commentThread);
      return this.commentThread;
    },
  },
  updated() {
    if (this.isListScrolledBottom) {
      this.scrollBottom();
    }
  },
  methods: {
    setComment() {
      this.$emit('set-comment', {
        commentThread: this.commentThread,
        commentText: this.commentText,
      });
      this.commentText = '';
    },
    removeComment() {
      this.$emit('remove-comment');
    },
    close() {
      this.$emit('comment-thread-closed');
    },
    onListScroll() {
      const listEl = this.$refs.list.$el;
      this.isListScrolledBottom = listEl.scrollTop === (listEl.scrollHeight - listEl.clientHeight);
    },
    scrollBottom() {
      this.$refs.list.$el.scrollTop = this.$refs.list.$el.scrollHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.threadContainer {
  border-top: 2px solid #3f47cdaa;
}

.commentList {
  min-height: 40px;
  max-height: 300px;
  overflow-y: auto;

  &.focused {
    max-height: auto;
  }
}
.headActionsContainer {
  position: relative;
  z-index: 1;

  & .actions {
    position: absolute;
    padding-right: 15px;
    right: 0;
    top: 8px;

    & .redButton {
      color: red;
    }
  }
}
</style>
